export default __webpack_public_path__ + "static/media/logo-dicoma.a5e264f3.svg";